export default class FDayaDukungTypeType {
  constructor(
    id,
    kode1,
    kode2,
    description,
    fdivisionBean,
    statusActive,
    baseId,
    lang,

    created,
    modified,
    modifiedBy
  ) {
    this.id = id;
    this.kode1 = kode1;
    this.kode2 = kode2;
    this.description = description;
    this.statusActive = statusActive;
    this.fdivisionBean = fdivisionBean;
    this.baseId = baseId;
    this.lang = lang;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
